import { createApp, App, Component } from "vue";
import { VueQueryPlugin } from "@tanstack/vue-query";
import { getActivePinia } from "pinia";
import router from "@/router";

type ModalInstance = {
  instance: App;
  node: HTMLElement;
};

const modalMap = new Map<string, ModalInstance>();

export const isModalOpen = (id: string) => modalMap.has(id);

// 打开弹窗
export const openModal = <P extends Record<string, unknown>>(
  id: string,
  config: {
    component: Component;
    props?: P;
  }
) => {
  if (modalMap.has(id)) {
    console.warn(`弹窗 ${id} 已打开`);
    return;
  }

  const modalNode = document.createElement("div");
  document.getElementById("app")?.appendChild(modalNode);

  const modalInstance = createApp(config.component, config.props)
    .use(router)
    .use(VueQueryPlugin);

  // 安装 Pinia，否则弹窗组件内部调用 useStore() 会失败
  const pinia = getActivePinia();
  if (pinia) {
    modalInstance.use(pinia);
  }

  modalInstance.mount(modalNode);
  modalMap.set(id, { instance: modalInstance, node: modalNode });
};

// 关闭指定 ID 的弹窗
export const closeModalById = (id: string) => {
  const instance = modalMap.get(id);
  if (instance) {
    instance.instance.unmount();
    instance.node.remove();
    modalMap.delete(id);
  }
};

// 关闭所有弹窗
export const closeAllModals = () => {
  modalMap.forEach((instance) => {
    instance.instance.unmount();
    instance.node.remove();
  });
  modalMap.clear();
};
